import Input from "../../../components/Input";
import Card from "../../../components/Card";
import React from "react";
import {Login} from "../../../types/Subscription";
import {useTranslation} from "react-i18next";

const LoginForm: React.FC<{data: Partial<Login>, changeData: (data: Partial<Login>) => void}> = (
    {
        data,
        changeData
    }
) => {
    const {t} = useTranslation(['settings'])
    return (
        <Card title={t("subscription.loginInfos")} classes={'my-3'}>
            <div className={'row'}>
                <div className={'col-12 col-md-6 my-3'}>
                    <Input
                        type={'email'}
                        placeholder={'E-Mail'}
                        property={'email'}
                        value={data.email ?? ''}
                        onChange={(property, value) => changeData({email: value})}
                    />
                </div>
                <div className={'col-12 col-md-6 my-3'}>
                    <Input
                        type={'password'}
                        placeholder={t("subscription.password")}
                        property={'password'}
                        value={data.password ?? ''}
                        onChange={(property, value) => changeData({password: value})}
                    />
                </div>
            </div>
        </Card>
    )
}

export default LoginForm
